export enum EvidenceType {
    publishedStudy,
    plannedStudy
}
